import React, { useState, useRef, useEffect } from 'react';
import { Container, Button, Row, Col, Image } from 'react-bootstrap';
import {Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';
import '../../Banner/_home-banner.scss';
import {BtnArrow} from '../../../../../resources/js/components/svgIcon';
import { Autoplay, FreeMode, Thumbs, EffectFade, Pagination } from 'swiper/modules';
import AOS from 'aos';

function AttractionsDetails({ DetailRecord, Constant }) {
    const CDN_URL = window.cdn_path;
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const mainSwiperRef = useRef(null);
    useEffect(() => {
        AOS.refresh();
    }, []);

    return (
        <>
        <section className='home-banner attraction-banner position-relative'>
            <div className='hb-img'>
                <Swiper
                    ref={mainSwiperRef}
                    pagination={{ clickable: true, dynamicBullets: true }}
                    loop={true}
                    spaceBetween={0}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    thumbs={{ swiper: thumbsSwiper }}
                    effect="fade"
                    fadeEffect={{ crossFade: true }}
                    modules={[Autoplay, FreeMode, Thumbs, EffectFade, Pagination]}
                    className="mySwiper2"
                >
                    { Constant?.ATTRACTIONSTHUMB?.split(',')[2] && DetailRecord?.varWebpImgURL ? (
                        DetailRecord?.varWebpImgURL?.split(',')?.map((item, index) => {
                            let webpImage = '';
                            if(item && Constant?.ATTRACTIONSTHUMB?.split(',')[2]){
                                webpImage = CDN_URL + 'caches/' + Constant?.ATTRACTIONSTHUMB?.split(',')[2].replace('*', 'x') + '/' + item;
                            } else {
                                webpImage = CDN_URL + 'assets/images/no-image.png';
                            }
                            return (
                                <SwiperSlide key={index}>
                                    <div className='thumbnail-container object-fit'>
                                        <div className='thumbnail'>
                                            <Image src={webpImage} alt={DetailRecord?.varTitle} title={DetailRecord?.varTitle} />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })
                    ) : (
                        DetailRecord?.varImgURL?.split(',')?.map((item, index) => {
                            let orignalImage = '';
                            orignalImage = CDN_URL + 'assets/images/'+ item;
                            return (
                                <SwiperSlide key={index}>
                                    <div className='thumbnail-container object-fit'>
                                        <div className='thumbnail'>
                                            <Image src={orignalImage} alt={DetailRecord?.varTitle} title={DetailRecord?.varTitle} />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })
                    ) }
                    <div className='caption d-flex align-items-center justify-content-center position-absolute z-1 top-0 start-0 bottom-0 end-0'>
                        <Container>
                            <Row>
                                <Col lg={12} className='text-center'>
                                    {DetailRecord?.varTagLine ? (
                                        <h2 className='title-small fw-normal text-white position-relative z-2'>{DetailRecord?.varTagLine}</h2>
                                    ) : ''}
                                    <div className='title-big text-uppercase'>{DetailRecord?.varTitle}</div>
                                    {/* DetailRecord?.varButtonTitle && DetailRecord?.varButtonLink ? (
                                        <Button className='banner-btn' variant="primary" href={DetailRecord?.varButtonLink} title={DetailRecord?.varButtonTitle}>{DetailRecord?.varButtonTitle}
                                        <BtnArrow/></Button>
                                    ) : ''*/}
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Swiper>
            </div>
            <div className='thumb-img position-absolute start-0 end-0 bottom-0 mx-auto'>
                <Swiper
                    onSwiper={setThumbsSwiper}
                    loop={true}
                    spaceBetween={30}
                    slidesPerView={1}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Thumbs]}
                    className="mySwiper"
                    breakpoints={{
                        567: { slidesPerView: 2 }, // iPads & Tablets
                        1024: { slidesPerView: 3 }, // Small desktops
                        1440: { slidesPerView: 4 }  // Large desktops
                    }}
                >
                </Swiper>
            </div>
        </section>
        <section className='inner-page-gap attraction-detail'>
            <Container>
                    {DetailRecord?.txtDescription ? (
                        <div className='cms' dangerouslySetInnerHTML={{ __html: DetailRecord?.txtDescription }}></div>
                    ) :
                    <div className='cms'>
                        <p>{ DetailRecord?.varShortDescription }</p>
                    </div>
                    }
					{ DetailRecord?.varButtonTitle && DetailRecord?.varButtonLink ? (
                        <Link className='banner-btn btn btn-primary d-inline-block mt-4' variant="primary" target="_blank" rel="noopener noreferrer" to={DetailRecord?.varButtonLink} title={DetailRecord?.varButtonTitle}>{DetailRecord?.varButtonTitle}                            
                        <BtnArrow/></Link>
                    ) : ''}
            </Container>
        </section>
        </>
    );

}

export default AttractionsDetails;
